import PropTypes from 'prop-types';
import React from 'react';

import MatchResultsRow from './MatchResultsRow';

function splitArray(array, chunkLen) {
  const chunkList = [];

  if (!array || array.length === 0) {
    return chunkList;
  }

  for (let i = 0; i < array.length; i += chunkLen) {
    const myChunk = array.slice(i, i + chunkLen);
    chunkList.push(myChunk);
  }
  return chunkList;
}
export default class SkirmishResults extends React.Component {
  static propTypes = {
    data: PropTypes.object,
  };

  render() {
    const {data} = this.props;
    const {format, rules, title, matchResults} = data;
    const chunkResults = splitArray(matchResults, 3);
    const rows = [];
    for (let i = 0; i < chunkResults.length; i++) {
      rows.push(<MatchResultsRow row={chunkResults[i]} key={`row-${i}`} />);
    }
    return (
      <section className="skirmish-results">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center">
              <h2>{format}</h2>
              <div className="rules" dangerouslySetInnerHTML={{__html: rules}} />
              <hr className="breakLine" />
            </div>
          </div>
          {chunkResults.length !== 0 ? (
            <div className="row">
              <div className="col-xs-12 text-center">
                <h1 className="orange">{title}</h1>
              </div>
              {rows}
            </div>
          ) : null}
        </div>
      </section>
    );
  }
}
